import { GoabIcon, GoabText } from '@abgov/angular-components';
import { Component } from '@angular/core';
import { buildHelpRequestMailtoHref } from '../../utils/help-request-mailto';

@Component({
  selector: 'app-email-support',
  imports: [GoabText, GoabIcon],
  templateUrl: './email-support.html',
  styleUrl: './email-support.scss',
})
export class EmailSupport {
  readonly emailHref = buildHelpRequestMailtoHref();
}
